module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"groups":"Groups","productBoostLegend":"The price of the product boost may differ from that shown."},"es":{"groups":"Agrupaciones","productBoostLegend":"El precio del producto promocionado puede diferir al mostrado."}}')
  delete Component.options._Ctor
}
